import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  PostulatedList,
  NoPostulatedProjects,
  PostulationShareDialog,
} from 'imports/ComponentsImports';

import {
  Stepper,
  CountdownTimer,
} from 'imports/DesignImports';

import {
  CircularProgress,
  RaisedButton,
  Divider,
} from 'material-ui';

const styles = {
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  headerContainer: {
    display: 'flex'
  },
  header: {
    marginLeft: '0.7em',
    marginBottom: '0px',
  },
  column1Container: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Lato'
  },
  column2Container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    fontFamily: 'Lato'
  },
  informationContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '2em 0px 1em 0px'
  },
  informationText: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  addButton: {
    border: '2px #212F55 solid',
    fontFamily: 'Lato',
    borderRadius: '0px'
  },
  sendButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '2em',
  },
}

class AreaPostulatedProjects extends Component {
  render(){
    return(
      <div>
        {this.props.approvedAreaProjects.length <= 0 ?
        <div>
          <div style={styles.informationContainer}>
            <div style={styles.informationText}>Proyectos que debes aprobar</div>
          </div>
          {this.props.projects.length > 0 ?
          <PostulatedList
            filterData={this.props.filterData}
            history={this.props.history}
            projects={this.props.projects}
            shownData={["name", "area", "leader", "implementation_date", "edit_and_delete"]}
            withButton={true}
            company={this.props.company}/> :
            <NoPostulatedProjects
              message='Aún no hay proyectos postulados. Puedes agregar un proyecto aquí'
              button={
                <RaisedButton
                  label='AGREGAR PROYECTO'
                  buttonStyle={styles.addButton}
                  backgroundColor='#FFFFFF'
                  onClick={this.props.raiseShareDialog}/>
              }/>
          }
        </div> :
        <div>
          <div style={styles.informationContainer}>
            <div style={styles.informationText}>Ya aprobaste los proyectos de tu área, a continuación los puedes ver</div>
          </div>
          <PostulatedList
            filterData={this.props.filterData}
            history={this.props.history}
            projects={this.props.approvedAreaProjects}
            shownData={["name", "area", "leader", "implementation_date", "edit_and_delete"]}
            company={this.props.company}/>
        </div>
        }
      </div>
    );
  }
}

class PostulationListView extends Component {
  constructor(props){
    super(props);
    this.state = {
      error: false,
      loading: true,
      projects: [],
      token: props.cookies.get('token'),
      user: props.cookies.get('user'),
      raiseShareDialog: false,
      postulationState: 'area',
      alertDialog: false,
      alertMessage: '',
      acceptLabel: '',
      cancelLabel: '',
      confirm: () => {},
      loadingDialog: false,
    }
  }

  componentDidMount() {
    this.getData();
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar los proyectos. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    if(this.props.done){
      return(
        <div>
          <h1 style={styles.header}> Portafolio de Proyectos </h1>
          <p style={{marginLeft:'25px', marginRight: '25px'}}>Estos son los proyectos que fueron postulados en la etapa de postulación. </p>
            <PostulatedList
              done={this.props.done}
              filterData={this.state.filterData}
              history={this.props.history}
              projects={this.state.user.position === 'Gerente Innovación' ? this.state.allPostulatedProjects : this.state.approvedAreaProjects}
              shownData={["name", "area", "leader", "implementation_date", "edit_and_delete"]}
              withButton={false}
              company={this.state.company}/>
        </div>
      );
    }
    return (
      <div style={styles.pageContainer}>
        <div style={styles.headerContainer}>
          <div style={styles.column1Container}>
            <h1 style={styles.header}> Portafolio de Proyectos </h1>
            <p style={{marginLeft:'25px', marginRight: '25px'}}>Estos son los proyectos postulados para conformar el portafolio de innovación. Puedes agregar proyectos a tu área o eliminar proyectos.</p>
          </div>
          <div style={styles.column2Container}>
            <CountdownTimer step="postulation" token={this.state.token} company_id={this.state.user.company_id}/>
            {this.state.approvedAreaProjects.length <= 0 &&
            <RaisedButton label='AGREGAR PROYECTO' buttonStyle={styles.addButton} backgroundColor='#FFFFFF' onClick={() => {this.setState({raiseShareDialog: true})}}/>
            }
        </div>
        </div>
        <Stepper step="postulation"/>
        <Divider />
          <div>
            <AreaPostulatedProjects
              projects={this.state.areaProjects}
              filterData={this.state.filterData}
              history={this.props.history}
              company={this.state.company}
              raiseShareDialog={() => this.setState({raiseShareDialog: true})}
              approvedAreaProjects={this.state.approvedAreaProjects}/>
            {this.state.raiseShareDialog ?
              <PostulationShareDialog
                company={this.state.user.company_id}
                apiToken={this.state.token}
                cancel={() => {this.setState({raiseShareDialog: false})}}
                confirm={() => this.props.history.push('/project_postulation/' + this.state.user.key)}
                userKey={this.state.user.key}
                history={this.props.history}
                /> : null
            }
            </div>
      </div>
    );
  }

  getData = () => {
    this.setState({loading: true, error: false});
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    var postulatedProjects = connection.get(routes.projectFullInformation)
    var companyData = connection.get(routes.company(this.state.user.company_id))
    var filterData = connection.get(routes.getFilters)
    Promise.all([postulatedProjects, companyData, filterData])
    .then((responses) => {
      this.setState({
        areaProjects: responses[0].data.filter((project) => {
          return project.state.length > 0 && project.state[0].state === "En proceso de postulación" && project.information.area.name === this.state.user.area
        }),
        approvedAreaProjects: responses[0].data.filter((project) => {
          return project.state.length > 0 && project.state[0].state === "Postulación aprobada por GA" && project.information.area.name === this.state.user.area
        }),
        allPostulatedProjects: responses[0].data.filter((project) => {
          return project.state.length > 0 && project.state.map(state => state.state).includes('Postulación aprobada por GA')
        }),
        company: responses[1].data,
        filterData: responses[2].data,
        error: false,
        loading: false,
      })
    })
    .catch((error) => {
      console.log(error);
      this.setState({ error: true, loading: false })
    });
  }
}

export default withRouter(withCookies(PostulationListView));



// WEBPACK FOOTER //
// ./src/views/postulation/PostulationListView.js